module.exports = __webpack_public_path__ + "static/media/phone-icon.e1d8b9d3.svg";